import React, { useState } from 'react';
import {
    Form,
    Col,
} from "reactstrap";
import "./Login.css";
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import {
    Box,
    Button,
    TextField,
    Typography  } from "@mui/material";
import { useRequestPassword } from "../../hooks/useAuth";

const RequestPassword = () => {
    const [Email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [errortext, setErrortext] = useState('');
    const requestPassword = useRequestPassword();

    const navigate = useNavigate();

    const handleSubmitButton = () => {
        setErrortext('');
        if (!Email) {
            swal({
                text: 'Please Fill In Your Email Adress',
                icon: "error"
            });
            return;
        }

        setLoading(true);
        let dataToSend = { Email: Email};
        requestPassword.mutate({ payload: dataToSend, navigate });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, boxSizing: 'border-box' }}>
            <Form className='registerForm' onSubmit={handleSubmitButton}>
                <h1 className='noticeHeader'>
                    <Typography color="textPrimary" variant="h2">Forgot Login</Typography>
                </h1>
                <p className='registerHeaderText'></p>
                <Typography color="textPrimary" variant="h5">Please enter your email to recover lost login information.</Typography>
                <Col>
                    <TextField
                            fullWidth
                            label="User Email"
                            margin="normal"
                            name="email"
                            onChange={(event) => setEmail(event.target.value)}
                            type="text"
                            value={Email}
                            variant="outlined"/>
                </Col>
                <Box my={2}>
                    <Button color="primary" className="registerBtn" onClick={handleSubmitButton}>Submit</Button>
                </Box>
            </Form>
        </div>
    );
};

export default RequestPassword;